// Service handling the geometry and size calculations of the HTML text
// using canvas for performance

import { Injectable } from "@angular/core";

export interface ITextCalculatorService {
    getTextWidth: (text: string, font: string) => number;
    getElementFont: (el: any) => string;
}

// Replacing the ruler approach from XSight 4.2
@Injectable({
    providedIn: 'root'
})
export class TextCalculatorService implements ITextCalculatorService {
    //
    private canvas: HTMLCanvasElement;

    /**
     * Gets any text width in pixels.
     *
     * @param text The text that will be measured
     * @param font The font used, can be retrieved by the getElementFont call
     * @return number The width of the text in pixels
     */
    getTextWidth = (text: string, font: string): number => {
        // re-use canvas object for better performance
        const canvas = this.canvas || (this.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    }

    /**
     * Gets the font from the HTML element.
     *
     * @param el The element checked, BODY font or default
     * @return css font property value: weight, size and family
     */
    getElementFont = (el: any = document.body): string => {
        const fontWeight = this.getCssStyle(el, 'font-weight') || 'normal';
        const fontSize = this.getCssStyle(el, 'font-size') || '16px';
        const fontFamily = this.getCssStyle(el, 'font-family') || 'Source Sans Pro';

        return `${fontWeight} ${fontSize} ${fontFamily}`;
    }

    private getCssStyle = (element: any, property: string): string => window.getComputedStyle(element, null).getPropertyValue(property);

}